<template>
  <v-card>
    <v-toolbar dark class="secondary">
      <v-toolbar-title>Edit Dropdrown</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn @click="$emit('closeDialog')" flat dark icon><v-icon>cancel</v-icon></v-btn>
    </v-toolbar>
    <v-layout ml-1>
      <v-text-field v-model="newDropDown" label="Add New Dropdown Item" prepend-icon="add" /><v-btn :disabled="!newDropDown" @click="addDropDown" dark color="cyan">Add</v-btn>
    </v-layout>
      <v-list>
      <template v-for="(item, index) in dropDowns">
        <v-list-tile :key="index">
          <v-list-tile-content>
            <v-layout>
              <v-btn @click="removeDropDown(item)" flat icon><v-icon color="red">cancel</v-icon></v-btn><span class="pt-2">{{ item }}</span>
              <v-spacer></v-spacer>
            </v-layout>
          </v-list-tile-content>
        </v-list-tile>
      </template>
    </v-list>
  </v-card>
</template>

<script>
export default {
  props: ['dropdownName'],
  data () {
    return {
      newDropDown: null
    }
  },
  computed: {
    dropDowns () {
      return this.$store.getters[this.dropdownName]
    }
  },
  methods: {
    addDropDown () {
      this.dropDowns.push(this.newDropDown)
      this.newDropDown = null
      this.$store.dispatch('changeDropDownList', {dropdownName: this.dropdownName, dropdowns: this.dropDowns})
    },
    removeDropDown (item) {
      const index = this.dropDowns.findIndex(i => i === item)
      this.dropDowns.splice(index, 1)
      this.$store.dispatch('changeDropDownList', {dropdownName: this.dropdownName, dropdowns: this.dropDowns})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/helpers/EditDropdown.vue